module.exports = __webpack_public_path__ + "static/biz-kimiz-fa1c2ad009c0bcf9796e8d58fb8e7cc6.png";